import React, { useEffect, useState } from "react";
import { Card, Spin, Button, Rate } from "antd";
import Style from './UserFeedbackModal.module.scss';
import { Info } from "react-bootstrap-icons";

const UserFeedbackModal = ({info,handelClose}) => {
    console.log(Info)
  return (
    <div className={Style.PageHolder}>
      <Card className={Style.CardHolder}>
          {info ? (
            <div className={Style.FeedbackDetails}>
              <div className={Style.scoreHolder}><Rate defaultValue={info.score} disabled style={{direction:'ltr'}}/></div>
              <p>بازخورد: {info.feedback}</p>
              <Button type="primary" onClick={handelClose} style={{width:'100%'}}>
                بازگشت
              </Button>
            </div>
          ) : (
            <p>بازخوردی یافت نشد.</p>
          )}
      </Card>
    </div>
  );
};

export default UserFeedbackModal;
